import React, { useLayoutEffect } from 'react';
import TopBar from '@/components/atelier/TopBar';
import Nav from '@/components/atelier/Nav';
import Footer from '@/components/atelier/Footer';
import EyebrowPill from '@/components/atelier/EyebrowPill';
import Button from '@/components/atelier/Button';
import { BUSINESS } from '@/lib/businessConfig';

// Branded 404 — noindex, no canonical, no structured data, plain internal links.
export default function NotFoundPage({ message = 'Η σελίδα που ψάχνεις δεν υπάρχει ή έχει μετακινηθεί.' }) {
  // Synchronous (useLayoutEffect): the soft-404 signals must be in the head before
  // the first paint the crawler snapshot captures.
  useLayoutEffect(() => {
    document.title = `Η σελίδα δεν βρέθηκε | ${BUSINESS.brandName}`;
    const setMeta = (name, content) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) { tag = document.createElement('meta'); tag.setAttribute('name', name); document.head.appendChild(tag); }
      tag.setAttribute('content', content);
    };
    setMeta('robots', 'noindex, follow');
    setMeta('prerender-status-code', '404');
    document.querySelectorAll('link[rel="canonical"], link[rel="alternate"][hreflang], script[data-seo-jsonld="true"]').forEach((n) => n.remove());
  }, []);

  return (
    <div className="bg-cream-bg text-warm-black min-h-screen">
      <TopBar />
      <Nav />
      <section className="px-[6vw] py-[120px] text-center max-w-editorial mx-auto">
        <EyebrowPill variant="dark" className="mb-7">404</EyebrowPill>
        <h1 className="font-serif text-display-l text-warm-black font-medium leading-[0.95] mb-7">
          Δεν βρέθηκε <em className="italic text-gold">η σελίδα.</em>
        </h1>
        <p className="text-body-l text-muted mb-10">{message}</p>
        <div className="flex gap-4 justify-center flex-wrap">
          <Button variant="primary" href="/services">Δες τις Υπηρεσίες →</Button>
          <Button variant="ghost" href="/journal">Journal</Button>
          <Button variant="ghost" href="/">Επιστροφή στην Αρχή</Button>
        </div>
      </section>
      <Footer />
    </div>
  );
}